import { defineComponent as _defineComponent } from 'vue'
import { openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { ref, useSlots } from 'vue'
import { cartChangeResource } from '@services/cart.service'
import { useShowModal } from '@composables/useModalOpener'
import { useCartStore } from '@store/cart'
import { useSimpleErrorsGetter } from '@/components/Forms/FormMixin'
import { useNotification } from '@kyvg/vue3-notification'
import useGlobal from '@composables/useGlobal'


export default /*@__PURE__*/_defineComponent({
  __name: 'ButtonRemove',
  props: {
  itemId: {
    type: [String, Number],
  },
  type: {
    type: String,
  },
  quantity: {
    type: [String, Number],
  },
},
  setup(__props) {

const props = __props

const slots = useSlots() as any

const { notify } = useNotification()

const { $t } = useGlobal()

const isLoad = ref(false)

const getCartData = () => {
  const cartStore = useCartStore()

  cartStore.getCartData()
}

const removeFromCart = () => {
  if (isLoad.value) return

  isLoad.value = true

  const formdata = {
    entities: [{
      element: {
        type: props.type,
        id: props.itemId.toString(),
      },
      quantity: Number(props.quantity) * -1,
    }]
  }
  cartChangeResource.execute({}, formdata).then(() => {
    notify({ title: $t('Товар удален из корзины'), type: 'success' })

    getCartData()
  }).catch(async (e: object) => {
    const parsed = await useSimpleErrorsGetter(e)

    const { entities } = parsed

    const text = $t('Обратитесь к администратору сайта для получения подробной информации')

    if (entities && entities[0]) {
      const title = entities[0].nonFieldErrors[0].message

      const message = {
        title,
        text,
      }
      useShowModal(message)
    } else {
      const message = {
        title: $t('Возникла непредвиденная ошибка'),
        text,
      }
      useShowModal(message)
    }
  }).finally(() => {
    isLoad.value = false
  })
}

const render = () => slots.default({
  removeFromCart,
})

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(render, { ref: "content" }, null, 512))
}
}

})